import ReportTypeScreen from "../../../Components/Reports/ReportTypeScreen";

function ReportedUsers() {
  return <ReportTypeScreen reportType="user" />;
}

export default ReportedUsers;
